import { ResponsiveContainer, BarChart, Bar, XAxis, Tooltip } from 'recharts';

export const WeekChart = ({ series = [], bars, height = 140, testId }) => {
  const data = series.map((s) => ({
    ...s,
    day: new Date(`${s.date}T00:00:00`).toLocaleDateString('en-IN', { weekday: 'short' }),
  }));
  return (
    <div style={{ height }} data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} barGap={2}>
          <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: '#9A8E85' }} />
          <Tooltip cursor={{ fill: '#F7F3EC' }} contentStyle={{ borderRadius: 12, border: '1px solid #E8E1D5', fontSize: 12 }} />
          {bars.map((b) => (
            <Bar key={b.key} dataKey={b.key} name={b.label} fill={b.color} radius={[6, 6, 0, 0]} maxBarSize={16} />
          ))}
        </BarChart>
      </ResponsiveContainer>
      <div className="flex gap-3 justify-center mt-1">
        {bars.map((b) => (
          <span key={b.key} className="inline-flex items-center gap-1 text-[10px] text-[#9A8E85] font-semibold">
            <span className="w-2 h-2 rounded-full" style={{ background: b.color }} /> {b.label}
          </span>
        ))}
      </div>
    </div>
  );
};
